var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrowSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29126 3.93164L5.16478 6.54393L8.03831 3.93164",
    stroke: "black",
    strokeWidth: 1.04492
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrowSvg);
export default __webpack_public_path__ + "static/media/downarrow_svg.5d465406064a23602a1d051223bd29fe.svg";
export { ForwardRef as ReactComponent };